export default __webpack_public_path__ + "13406faf7f6b8d86e7b63405aecca2b5.png";